import React from 'react';
import styled, { css } from 'styled-components';
import Content from '../components/Content';
import { Header, SubHeading, Paragraph } from '../components/TextComponents';
import Spacer from '../components/Spacer';
import Footer from '../components/Footer';
import Button from '../components/Button';
import { MobileOnly } from '../components/MobileOnly';
// Styled components for Header and Paragraph
// (These styles were provided in your previous snippet)
export const List = styled.ul`
  list-style-type: disc;
  margin-left: 2rem;

  @media (max-width: 767px) {
    margin-left: 0rem; /* Adjust the margin for mobile view */
  }
`;

const FlexContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
`;

const FlexItem = styled.div`
  margin-right: 1rem;
`;

const DownloadLink = styled.a`
  text-decoration: none;
  color: #007bff;
  &:hover {
    text-decoration: underline;
  }
`;

const ExperienceItem = styled.li`
  margin-bottom: 1rem;
`;

const JobTitle = styled.div`
  font-weight: bold;
`;

const DateRange = styled.div`
  font-style: italic;
`;

const Home = () => {
  return (
    <div style={{ overflowX: 'hidden' }}xx>
      <Spacer />
      <MobileOnly>     
         <Button type='back' align="left" />
      </MobileOnly>
      <Content align="left">
        <Header>About</Header>
        <Paragraph>
        I’m Jackson, a graduate of Computation Arts at Concordia University and a multidisciplinary artist, writer, and designer. My practice sits at the intersection of computer science, fine arts, and literary education, offering a distinct perspective grounded in analytical precision, media literacy, and creative experimentation. I specialize in crafting work that is technically complex, conceptually sharp, and stylistically original—often obsessive, absurd, and tongue-in-cheek.

<br></br><br></br>My expertise spans a wide range of disciplines, including 3D modelling, game development, VR/AR, AI, front- and back-end web design, UI/UX, circuits, painting, and writing, alongside industry-standard tools such as Photoshop, Illustrator, After Effects, and InDesign. Through this hybrid approach, I aim to create work that balances technical rigor with experimentation and stylistic clarity. </Paragraph>
      </Content>

      <Content align="right">
        <Header align="left">Experience</Header>
        <Paragraph>
          <List>
            <ExperienceItem>
              <JobTitle>Graphics Editor: The Sophia Review Philosophy Journal</JobTitle>
              <DateRange>March 2024 - Present</DateRange>
              Responsible for creating striking vector graphics for print, while formatting the work of others to fit into one cohesive style.
            </ExperienceItem>
            <ExperienceItem>
              <JobTitle>Graphics Editor: The Encore Poetry Project</JobTitle>
              <DateRange>January 2024 - Present</DateRange>
              Responsible for creating intricate visuals for print and web in varying styles to complement written content. Works in tandem with the editorial team to ensure each issue maintains its distinctive aesthetic identity.
            </ExperienceItem>
            <ExperienceItem>
              <JobTitle>Exhibition Planner</JobTitle>
              <DateRange>2025 – Present</DateRange>
              April 2025: Helped organize Concordia University's <i>Nodes.Noeuds</i> exhibition, a showcase of student work from the Design and Computation Arts programs. Responsibilities included coordinating with artists, curating the exhibition space, and creating a comprehensive visual identity.
              <br />April 2025: helped organize Concordia and McGill University's <i>Convergence</i> exhibition, a showcase of interactive works combining art with neuroscience concepts.
            </ExperienceItem>
            <ExperienceItem>
              <JobTitle>3d / Environmental Artist</JobTitle>
              <DateRange>2025 – Present</DateRange>
              August 2025 – January 2026: Modelled 3D architectural environments for MOD Interior Design Inc.
              </ExperienceItem>
          </List>
        </ Paragraph>
      </ Content>
      <Content align = "left">
        <Paragraph>
        <Header>Skills</Header>
          <FlexContainer>
            <FlexItem>
              <SubHeading>Game Design</SubHeading>
              <List>
                <li>Unreal Engine</li>
                <li>Audiokinetic Wwise</li>
                <li>VR Development for Meta Quest</li>
                <li>Blender</li>
                <li>C++, Java, and Blueprints</li>
              </List>
            </FlexItem>
            <FlexItem>
              <SubHeading>Web Design</SubHeading>
              <List>
                <li>HTML, CSS, and Javascript</li>
                <li>UI/UX Design in Figma</li>
                <li>Node.js-Based Servers</li>
                <li>React.js integration</li>
                <li>MondoDB integration</li>
              </List>
            </FlexItem>
            <FlexItem>
              <SubHeading>Interactive Media</SubHeading>
              <List>
                <li>Circuit Python</li>
                <li>Raspberry Pi</li>
                <li>Max/MSP</li>
                <li>Touch Designer</li>
                <li>Ableton Live</li>                
              </List>
            </FlexItem>
            <FlexItem>
              <SubHeading>Miscellaneous</SubHeading>
              <List>
                <li>Oil Painting</li>
                <li>Creative Writing</li>
              </List>
            </FlexItem>
          </FlexContainer>
          <Paragraph>
            <DownloadLink href="/JacksonDunnigan_CV.pdf" download>Download CV</DownloadLink>
          </Paragraph>
        </Paragraph>
      </Content>

      <Content align="right">
        <Header>Contact</Header>
        <Paragraph>
          contact@jacksondunnigan.ca <br/>
        </Paragraph>
      </Content>
      <Footer />
      
    </div>
  );
};

export default Home;
